module.exports = __webpack_public_path__ + "static/media/logo.b41ab62c.png";